import { useClient } from './useClient';
import { useChannel } from './useChannel';
import { useMembers } from './useMembers';
import { useMessages } from './useMessages';
import { Types } from '../../../states/actions';
import { useError } from '../../../../providers/ErrorProvider/context';
/**
 * `useConversationSDK` hook can be used to exchange data with `Twilio Conversation SDK`
 *
 * @param chatState
 * @param dispatch
 * @param sessionToken
 * @param apiBaseurl
 */
export function useConversationSDK(chatState, dispatch, sessionToken, apiBaseurl, userType) {
    var onException = useError().onException;
    try {
        // useClient hook to create a Twilio Conversation client
        useClient(chatState, dispatch, sessionToken, apiBaseurl);
        // useChannel hook to retrieve Twilio Conversation channel
        useChannel(chatState, dispatch);
        // useMessages hook to retrieve and update Channel Messages
        useMessages(chatState, dispatch, sessionToken, apiBaseurl, userType);
        // useMembers hook to retrieve Twilio Conversation Channel Members
        useMembers(chatState, dispatch);
    }
    catch (err) {
        dispatch({
            type: Types.UPDATE_ERROR,
            payload: err,
        });
        onException(new Error("@lendi/chat: something wrong with Twilio Conversation: ".concat(err)));
    }
}
//# sourceMappingURL=index.js.map